import { BehaviorSubject } from 'rxjs';

export const localCommsSubject = new BehaviorSubject<boolean>(false);
